
module.exports = {
  // title:Cookie.get('siteName') || '有有宝', //配置显示在浏览器标签的title、底部信息、部分信息展示的值
  title: '有有宝', // 配置显示在浏览器标签的title、底部信息、部分信息展示的值
  icpCard: '', // icp证
  btnDisable: false,
  company: {
    href: '',
    name: '',
  }, // 公司信息
  icpMessage: '', // icp备案
}

// if (this.config.btnDisable) {
//   return
// }



// WEBPACK FOOTER //
// ./src/config/index.js